<template>
  <div>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap justify-center>
                <v-flex xs12 sm6 md3>
                  <text-input
                    :form="form"
                    label="Pregunta"
                    :v-errors="errors"
                    :value.sync="form.title"
                    name="title"
                    v-validate="'required'"
                  ></text-input>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-select
                    v-model="form.type"
                    :items="questionTypes"
                    label="Tipo de pregunta"
                    item-text="text"
                    item-value="value"
                    v-validate="'required'"
                    :v-errors="errors"
                    :value.sync="form.type"
                    :form="form"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <select-multiple-input
                    v-validate="'required'"
                    :form="form"
                    :items="grades"
                    label="Grados"
                    :v-errors="errors"
                    :value.sync="form.grades"
                    name="grades"
                  ></select-multiple-input>
                </v-flex>

                <v-flex xs12 sm3 md1>
                  <check-input
                    :form="form"
                    label="Activo"
                    :v-errors="errors"
                    :value.sync="form.status"
                    name="status"
                    v-validate="'required'"
                  ></check-input>
                </v-flex>
                <v-flex xs12 sm3 md1>
                  <v-btn v-if="!editing" color="primary" @click="saveQuestion">Guardar</v-btn>
                  <v-btn v-else color="secondary" @click="updateQuestion">Actualizar</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap justify-center>
                <v-expansion-panel>
                  <v-expansion-panel-content
                    v-for="(question, i) in questions"
                    :key="i"
                    :disabled="question.status != 1"
                  >
                    <template v-slot:header>
                      <div>
                        <v-layout row wrap>
                          <v-flex xs9>
                            <span class="headline">{{`${i+1}. ${question.title}`}}</span>
                          </v-flex>
                          <v-flex xs2>
                            <v-tooltip top>
                              <v-icon
                                medium
                                class="mr-2"
                                @click.prevent="editQuestion(question)"
                                slot="activator"
                              >
                                edit
                              </v-icon>
                              <span>Editar</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <v-icon
                                medium
                                class="mr-2"
                                @click.prevent="tryDeleteQuestion(question.id)"
                                slot="activator"
                              >
                                delete
                              </v-icon>
                              <span>Eliminar</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <survey-question-options
                      :type="question.type"
                      :options="question.options"
                      :surveyId="survey.id"
                      :questionId="question.id"
                      v-on:updateData="init()"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="deleteDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Eliminar
        </v-card-title>

        <v-card-text>
          Desea eliminar la pregunta?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            flat
            @click="deleteQuestion"
          >
            Si
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="deleteDialog = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import Form from 'vform'
  import SurveyQuestionOptions from './survey_question_options.vue'

  export default {
    name: 'survey-questions-view',
    components: {
      'survey-question-options': SurveyQuestionOptions,
    },
    props: {
      survey: {
        type: Object,
        default: {}
      },
    },
    data() {
      return {
        questions: [],
        questionTypes: [
          { value: 'TEXT', text: 'Texto' },
          { value: 'ONLY_OPTION', text: 'Única opción' },
          { value: 'MULTIPLE_OPTION', text: 'Multiple opción' },
        ],
        grades: [{value: 'ALL', text: 'Todos'}],
        form: new Form({
          survey_id: '',
          title: '',
          type: '',
          grades: ['ALL'],
          status: true,
        }),
        editing: false,
        deleteDialog: false,
        questionToDelete: ''
      }
    },
    watch: {
      survey(newValue, oldValue) {
        this.form.survey_id = newValue.id
        this.init()
      },
      deleteDialog(newValue, oldValue) {
        if (!newValue) {
          this.questionToDelete = ''
        }
      }
    },
    methods: {
      async init() {
        axios.get(`/api/survey/${this.survey.id}/questions`)
          .then(response => {
            if (response.status === 200) {
              this.questions = response.data.questions
            }
          })

        const grades = await axios.get('/api/school_grades')
        grades.data.map(grade => this.grades.push({ value: grade.name, text: grade.name }));
      },
      async saveQuestion() {
        if (await this.formHasErrors()) return;

        const { status } = await this.form.post('/api/survey/question')

        if (status === 200) {
          this.init()
          this.clearForm()
        }

      },
      editQuestion(question) {
        this.editing = true
        this.form = new Form({
          id: question.id,
          survey_id: this.survey.id,
          title: question.title,
          type: question.type,
          grades: question.grades,
          status: question.status == 1,
        })
      },
      async updateQuestion() {
        if (await this.formHasErrors()) return;

        const { status } = await this.form.put('/api/survey/question')

        if (status === 200) {
          this.init()
          this.clearForm()
        }
      },
      tryDeleteQuestion(id) {
        this.questionToDelete = id
        this.deleteDialog = true
      },
      deleteQuestion() {
        const id = this.questionToDelete
        this.deleteDialog = false
        axios.delete(`/api/survey/question/${id}`)
          .then(response => {
            if (response.status === 200) {
              this.init()
            }
          })
      },
      clearForm() {
        this.editing = false
        this.form = new Form({
          survey_id: this.survey.id,
          title: '',
          type: '',
          grades: ['ALL'],
          status: true,
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/surveys/survey_questions.vue